"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
  // Yes, there's really no need for `Object.defineProperty` here
  NodeList.prototype.forEach = Array.prototype.forEach;
}
window.theme = window.theme || {};
(function () {
  "use strict";

  var config = {
    common: {
      storefrontApiUrl: "/api/2021-07/graphql.json"
    },
    staging: {
      // apiUrl: "http://localhost:4001",
      apiUrl: "https://staging-api-ywhuwvm4ma-ts.a.run.app",
      storefrontAccessToken: "c026098bac3ae0a3aeba4eb2afa517b0"
    },
    production: {
      //apiUrl: 'http://localhost:4001',
      apiUrl: "https://production-api-ywhuwvm4ma-ts.a.run.app",
      storefrontAccessToken: "42586a5ab14bd2ee1e3d3e9a4b96f551"
    }
  };
  var envConfig = !window.location.hostname.endsWith("fila.com.au") && !window.location.hostname.endsWith("fila-australia-production.myshopify.com") && !window.location.hostname.endsWith("fila.co.nz") ? config.staging : config.production;
  theme.ENV = $.extend(config.common, envConfig);
  theme.constants = {
    LOCALSTORAGE_GUEST_ID: "WISHLIST_GUEST_ID"
  };
  theme.settings = {};
  theme.delegate = {
    on: function on(event, callback, options) {
      if (!this.namespaces)
        // save the namespaces on the DOM element itself
        this.namespaces = {};
      this.namespaces[event] = callback;
      options = options || false;
      this.addEventListener(event.split(".")[0], callback, options);
      return this;
    },
    off: function off(event) {
      if (!this.namespaces) {
        return;
      }
      this.removeEventListener(event.split(".")[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  theme.utils = {
    defaultTo: function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    },
    wrap: function wrap(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
    debounce: function debounce(wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      };
    },
    throttle: function throttle(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      };
    },
    prepareTransition: function prepareTransition(el, callback) {
      el.addEventListener("transitionend", removeClass);
      function removeClass(evt) {
        el.classList.remove("is-transitioning");
        el.removeEventListener("transitionend", removeClass);
      }
      el.classList.add("is-transitioning");
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === "function") {
        callback();
      }
    },
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function compact(array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
    serialize: function serialize(form, returnJson) {
      var arr = [];
      var json = {};
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ["file", "reset", "submit", "button"].indexOf(field.type) > -1) return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            json[field.name] = option.value;
            arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(option.value));
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked) return;
        json[field.name] = field.value;
        arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
      });
      return returnJson ? json : arr.join("&");
    },
    fetch: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      fetch.toString = function () {
        return _fetch.toString();
      };
      return fetch;
    }(function (url, options) {
      return new Promise(function (resolve, reject) {
        fetch(url, options).then(function (response) {
          response.json().then(function (data) {
            if (response.status >= 400) reject(data);else resolve(data);
          });
        })["catch"](function (error) {
          reject(error);
        });
      });
    }),
    fetchWithTimeout: function fetchWithTimeout(url, options) {
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7000;
      return new Promise(function (resolve, reject) {
        fetch(url, options).then(resolve, reject);
        if (timeout) {
          var e = new Error("Connection timed out");
          setTimeout(reject, timeout, e);
        }
      });
    },
    getQueryParams: function getQueryParams(name) {
      var params = {};
      location.search.substr(1).split("&").forEach(function (item) {
        params[item.split("=")[0]] = item.split("=")[1];
      });
      if (name) return params[name];
      return params;
    },
    range: function range(count, startAt) {
      var _startAt = startAt || 0;
      return Array.apply(null, Array(count)).map(function (_, i) {
        return i + _startAt;
      });
    }
  };
  theme.a11y = {
    trapFocus: function trapFocus(options) {
      var eventsName = {
        focusin: options.namespace ? "focusin." + options.namespace : "focusin",
        focusout: options.namespace ? "focusout." + options.namespace : "focusout",
        keydown: options.namespace ? "keydown." + options.namespace : "keydown.handleFocus"
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(function (el) {
        return el.offsetParent !== null;
      });
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
      options.container.setAttribute("tabindex", "-1");
      options.elementToFocus.focus();
      document.documentElement.off("focusin");
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });
      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function removeTrapFocus(options) {
      var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
      if (options.container) {
        options.container.removeAttribute("tabindex");
      }
      document.documentElement.off(eventName);
    },
    /** targetElement will be the only element scrollable on the page, e.g. a modal. */
    lockScrolling: function lockScrolling(targetElement) {
      bodyScrollLock.disableBodyScroll(targetElement, {
        reserveScrollBarGap: true
      });
      // bodyScrollLock.disableBodyScroll(targetElement);
      // theme.a11y.preserveScrollBar()
      // var el = element ? element : document.documentElement
      // document.documentElement.classList.add('lock-scroll')
      // el.on('touchmove', function () {
      //   return true
      // })
    },

    unlockScrolling: function unlockScrolling(targetElement) {
      if (targetElement) bodyScrollLock.enableBodyScroll(targetElement);else bodyScrollLock.clearAllBodyScrollLocks();
      // document.body.style.paddingRight = 0
      // document.body.style.marginRight = 0
      // document.documentElement.classList.remove('lock-scroll')
      // var el = element ? element : document.documentElement
      // el.off('touchmove')
    },

    // https://github.com/theKashey/react-remove-scroll-bar
    preserveScrollBar: function preserveScrollBar() {
      function parse(x) {
        return parseInt(x || "", 10) || 0;
      }
      function getOffset() {
        var cs = window.getComputedStyle(document.body);
        var left = cs.marginLeft;
        var right = cs.marginRight;
        return [parse(left), parse(right)];
      }
      if (typeof window === "undefined") {
        return;
      }
      var offsets = getOffset();
      var documentWidth = document.documentElement.clientWidth;
      var windowWidth = window.innerWidth;
      var left = offsets[0];
      var right = offsets[1];
      var gap = Math.max(0, windowWidth - documentWidth + right - left);
      document.body.style.paddingRight = right + "px";
      document.body.style.marginRight = gap + "px";
    }
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on("keyup.tab", function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add("tab-outline");
      document.documentElement.off("keyup.tab");
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = function () {
    var moneyFormat = "${{amount}}";
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ",");
        decimal = theme.utils.defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          if (superScript && value && value.includes(".")) {
            value = value.replace(".", "<sup>") + "</sup>";
          }
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          if (superScript && value && value.includes(".")) {
            value = value.replace(",", "<sup>") + "</sup>";
          }
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
      }
      return formatString.replace(placeholderRegex, value).replace(".00", "");
    }
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
      return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    };
  }();
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this));
    document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this));
    document.addEventListener("shopify:section:select", this._onSelect.bind(this));
    document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this));
    document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this));
    document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
  };
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function _createInstance(container, constructor, scope) {
      var id = container.getAttribute("data-section-id");
      var type = container.getAttribute("data-section-type");
      constructor = constructor || this.constructors[type];
      if (typeof constructor === "undefined") {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
      this.instances.push(instance);
    },
    _findInstance: function _findInstance(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
    _removeInstance: function _removeInstance(id) {
      var i = this.instances.length;
      var instance;
      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
      return instance;
    },
    _onSectionLoad: function _onSectionLoad(evt, subSection, subSectionId) {
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector("[data-section-id]");
      if (!section) {
        return;
      }
      this._createInstance(section);
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll("[data-subsection]");
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === "function") {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event("scroll"));
      }, 200);
    },
    _onSectionUnload: function _onSectionUnload(evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
        if (isEventInstance) {
          if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
          }
        }
        return !isEventInstance;
      });
    },
    loadSubSections: function loadSubSections(scope) {
      var _this = this;
      var sections = scope ? scope.querySelectorAll("[data-subsection]") : document.querySelectorAll("[data-subsection]");
      sections.forEach(function (el) {
        _this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
    _onSelect: function _onSelect(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
      if (typeof instance !== "undefined" && typeof instance.onSelect === "function") {
        instance.onSelect(evt);
      }
    },
    _onDeselect: function _onDeselect(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
      if (typeof instance !== "undefined" && typeof instance.onDeselect === "function") {
        instance.onDeselect(evt);
      }
    },
    _onBlockSelect: function _onBlockSelect(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
      if (typeof instance !== "undefined" && typeof instance.onBlockSelect === "function") {
        instance.onBlockSelect(evt);
      }
    },
    _onBlockDeselect: function _onBlockDeselect(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
      if (typeof instance !== "undefined" && typeof instance.onBlockDeselect === "function") {
        instance.onBlockDeselect(evt);
      }
    },
    register: function register(type, constructor, scope) {
      this.constructors[type] = constructor;
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
      sections.forEach(function (container) {
        this._createInstance(container, constructor, scope);
      }.bind(this));
    },
    reinit: function reinit(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance["type"] === section) {
          if (typeof instance.forceReload === "function") {
            instance.forceReload();
          }
        }
      }
    }
  });
  theme.Modals = function () {
    function Modal(id, name, options) {
      var selectors = {
        openButton: ".modal__open-button--" + name,
        closeButton: ".modal__close-button",
        backdrop: ".modal__backdrop"
      };
      var classes = {
        openClass: "modal--open",
        bodyOpenClass: "modal-open"
      };
      var settings = {
        // closeOffContentClick: true,
      };
      this.id = id;
      this.modal = document.getElementById(id);
      this.classes = classes;
      this.selectors = selectors;
      if (!this.modal) {
        return false;
      }
      this.modalContent = this.modal.querySelector(".modal__content");
      this.config = Object.assign(settings, options);
      this.isOpen = false;
      this.activeSource = null;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
      this.init();
    }
    Modal.prototype.init = function () {
      var _this2 = this;
      document.querySelectorAll(this.selectors.openButton).forEach(function (btn) {
        btn.setAttribute("aria-expanded", "false");
        btn.addEventListener("click", _this2.open.bind(_this2));
      });
      this.modal.querySelectorAll(this.selectors.closeButton).forEach(function (btn) {
        btn.addEventListener("click", _this2.close.bind(_this2));
      });
      this.modal.querySelector(this.selectors.backdrop).addEventListener("click", this.close.bind(this));

      // if (window.pendingOpenQuickViewEvent) {
      //   this.open(window.pendingOpenQuickViewEvent);
      //   window.pendingOpenQuickViewEvent = null;
      // }
    };

    Modal.prototype.open = function (evt) {
      // don't open an opened modal
      if (this.isOpen) {
        return;
      }
      this.activeSource = null;

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        if (evt.currentTarget) {
          // save the source of the click, we'll focus to this on close
          this.activeSource = evt.currentTarget.setAttribute("aria-expanded", "true");
        }
      }
      this.modal.classList.add(this.classes.openClass);
      document.documentElement.classList.add(this.classes.bodyOpenClass);
      this.isOpen = true;
      theme.a11y.lockScrolling(this.modalContent);

      // theme.a11y.trapFocus({
      //   container: this.modal,
      //   elementToFocus: this.focusOnOpen,
      //   namespace: 'modal_focus'
      // });

      document.dispatchEvent(new CustomEvent("modalOpen"));
      document.dispatchEvent(new CustomEvent("modalOpen." + this.id));
      this.bindEvents();
    };
    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.isOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      // if (evt) {
      //   if (evt.target.closest(".js-modal-close")) {
      //     // Do not close if using the modal close button
      //   } else if (evt.target.closest(".modal__inner")) {
      //     return;
      //   }
      // }

      // deselect any focused form elements
      document.activeElement.blur();
      this.modal.classList.remove(this.classes.openClass);
      document.documentElement.classList.remove(this.classes.bodyOpenClass);
      if (this.activeSource && this.activeSource.getAttribute("aria-expanded")) {
        this.activeSource.setAttribute("aria-expanded", "false").focus();
      }
      theme.a11y.unlockScrolling(this.modalContent);

      // if (this.isSolid) {
      //   document.documentElement.classList.remove(
      //     this.config.bodyOpenSolidClass
      //   );
      // }

      this.isOpen = false;

      // theme.a11y.removeTrapFocus({
      //   container: this.modal,
      //   namespace: 'modal_focus'
      // });

      document.dispatchEvent(new CustomEvent("modalClose." + this.id));
      this.unbindEvents();
    };
    Modal.prototype.bindEvents = function () {
      window.on("keyup.modal", function (evt) {
        if (evt.keyCode === 27) {
          // ESC
          this.close();
        }
      }.bind(this));
    };
    Modal.prototype.unbindEvents = function () {
      document.documentElement.off(".modal");
    };
    return Modal;
  }();
  theme.sizeGuide = function () {
    var ids = {
      UNISEX: "SIZE_GUIDE_UNISEX",
      WOMENS: "SIZE_GUIDE_WOMENS",
      MENS: "SIZE_GUIDE_MENS",
      KIDS: "SIZE_GUIDE_KIDS",
      FOOTWEAR: "SIZE_GUIDE_FOOTWEAR"
    };
    return {
      sizeGuideIds: ids,
      getSizeGuideId: function getSizeGuideId(options) {
        if (options.type.includes("SOCK")) return ids.FOOTWEAR;
        if (options.isUnisex && !options.type.startsWith("FOOTWEAR")) return ids.UNISEX;
        if (!options.type) return null;
        if (options.type.startsWith("WOMENS")) return ids.WOMENS;
        if (options.type.startsWith("FOOTWEAR")) return ids.FOOTWEAR;
        if (options.type.startsWith("KIDS")) return ids.KIDS;
        if (options.type.startsWith("MENS")) return ids.MENS;
        return null;
      }
    };
  }();
  theme.Product = function () {
    var classes = {
      onSale: "sale-price",
      disabled: "disabled",
      isModal: "is-modal",
      loading: "loading",
      loaded: "loaded",
      hidden: "hide",
      visuallyHide: "visually-invisible"
    };
    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute("data-section-id");
      this.inModal = container.dataset.modal === "true";
      this.modal;
      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: ".product-" + sectionId,
        inventory: container.dataset.inventory || false,
        incomingInventory: container.dataset.incomingInventory || false,
        modalInit: false,
        modalSizeGuideInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: "620x",
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping,
        isUnisex: container.dataset.unisex == "true",
        sizeGuideId: theme.sizeGuide.getSizeGuideId({
          type: container.dataset.productType,
          isUnisex: container.dataset.unisex == "true"
        }),
        freeGiftHandle: container.dataset.freeGiftHandle
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = ".product-" + sectionId + "-modal";
        this.modal = document.getElementById("QuickViewModal-" + sectionId);
      }
      this.selectors = {
        variantsJson: "VariantsJson-" + sectionId,
        currentVariantJson: "CurrentVariantJson-" + sectionId,
        form: "#AddToCartForm-" + sectionId,
        media: "[data-product-media-type-model]",
        closeMedia: ".product-single__close-media",
        photoThumbs: ".product__thumb-" + sectionId,
        thumbSlider: "#ProductThumbs-" + sectionId,
        thumbScroller: ".product__thumbs--scroller",
        mainSlider: "#ProductPhotos-" + sectionId,
        imageContainer: "[data-product-images]",
        productImageMain: ".product-image-main--" + sectionId,
        priceWrapper: ".product__price-wrap-" + sectionId,
        price: "#ProductPrice-" + sectionId,
        comparePrice: "#ComparePrice-" + sectionId,
        priceA11y: "#PriceA11y-" + sectionId,
        comparePriceA11y: "#ComparePriceA11y-" + sectionId,
        unitWrapper: ".product__unit-price-wrapper--" + sectionId,
        unitPrice: ".product__unit-price--" + sectionId,
        unitPriceBaseUnit: ".product__unit-base--" + sectionId,
        sku: ".product__sku-" + sectionId,
        inventory: "#ProductInventory-" + sectionId,
        incomingInventory: "#ProductIncomingInventory-" + sectionId,
        addToCart: "#AddToCart-" + sectionId,
        addToCartText: "#AddToCartText-" + sectionId,
        originalSelectorId: "#ProductSelect-" + sectionId,
        singleOptionSelector: ".variant__input-" + sectionId,
        variantColorSwatch: ".variant__input--name-swatch-" + sectionId,
        variantLabel: function variantLabel(index) {
          return "#VariantLabel-" + sectionId + "-" + index;
        },
        modalFormHolder: "#ProductFormHolder-" + sectionId,
        availabilityContainer: "#StoreAvailabilityHolder-" + sectionId,
        sizeGuideButton: ".product__size-guide-button",
        returnsPolicyButton: ".product__returns_policy-button"
      };
      this.cache = {
        form: container.querySelector(this.selectors.form),
        mainSlider: container.querySelector(this.selectors.mainSlider),
        thumbSlider: container.querySelector(this.selectors.thumbSlider),
        thumbScroller: container.querySelector(this.selectors.thumbScroller),
        productImageMain: container.querySelector(this.selectors.productImageMain),
        sizeGuideButton: container.querySelector(this.selectors.sizeGuideButton),
        returnsPolicyButton: container.querySelector(this.selectors.returnsPolicyButton),
        // Price-related
        priceWrapper: container.querySelector(this.selectors.priceWrapper),
        comparePriceA11y: container.querySelector(this.selectors.comparePriceA11y),
        comparePrice: container.querySelector(this.selectors.comparePrice),
        price: container.querySelector(this.selectors.price),
        priceA11y: container.querySelector(this.selectors.priceA11y)
      };
      this.init();
    }
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function init() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener("modalOpen.QuickViewModal-" + this.sectionId, this.openModalProduct.bind(this));
          document.addEventListener("modalClose.QuickViewModal-" + this.sectionId, this.closeModalProduct.bind(this));
        }
        if (!this.inModal) {
          this.formSetup();
          this.initImageSlideshow();
          this.initLightbox();
          this.setupSizeGuideButton();
          this.setupReturnsPolicyButton();
        }
      },
      onUnload: function onUnload() {},
      formSetup: function formSetup() {
        this.initQtySelector();
        this.initVariants();
        this.container.querySelector(this.selectors.form).addEventListener("submit", this.handleAddToCart.bind(this));
      },
      handleAddToCart: function handleAddToCart(event) {
        var formData = new FormData(document.querySelector("#AddToCartForm-" + this.sectionId));
        var id = "";
        var qty = 0;
        var _iterator = _createForOfIteratorHelper(formData.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pair = _step.value;
            if (pair[0] === "id") {
              id = pair[1];
            }
            if (pair[0] === "quantity") {
              qty = pair[1];
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var freeGiftHandle = this.settings.freeGiftHandle;

        /* Try to open the Add Free Gift modal. If that fails for whatever reason, proceed as usual
         * to not interrupt the add to cart flow. */
        if (freeGiftHandle) {
          try {
            openAddFreeGiftModal(freeGiftHandle, id, qty);
            event.stopPropagation();
            event.preventDefault();
            return false;
          } catch (e) {
            console.error("Unable to open free gift modal", e);
          }
        }

        // showBundle(hasBundle, { variantID: id, quantity: qty, bool: false, productId: productId })
        addToCart(id, qty);
        event.stopPropagation();
        event.preventDefault();
        return false;
      },
      setupSizeGuideButton: function setupSizeGuideButton() {
        if (!this.cache.sizeGuideButton) return;
        this.cache.sizeGuideButton.addEventListener("click", this.openSizeGuideModal.bind(this));
      },
      setupReturnsPolicyButton: function setupReturnsPolicyButton() {
        this.cache.returnsPolicyButton.addEventListener("click", this.openReturnsPolicyModal.bind(this));
      },
      openReturnsPolicyModal: function openReturnsPolicyModal(event) {
        event.preventDefault();
        window.openReturnsPolicyModal(event.currentTarget);
        return false;
      },
      openSizeGuideModal: function openSizeGuideModal(event) {
        if (this.settings.sizeGuideId) {
          event.preventDefault();
          window.openSizeGuideModal(this.settings.sizeGuideId, event.currentTarget);
          return false;
        }
      },
      initLightbox: function initLightbox() {
        if (!window.lightbox) return;
        window.lightbox.init();
      },
      initImageSlideshow: function initImageSlideshow() {
        var NUMBER_OF_GRID_ITEMS = 4;
        var selector = ".product__images--slideshow";
        var element = $(this.container).find(selector);
        element.slick({
          slidesToShow: 4,
          initialSlide: 4,
          swipeToSlide: true
        });
        element.on("click", selector + "-slide", handleClickSlide);
        function handleClickSlide(event) {
          var clickedIndex = parseInt(event.currentTarget.dataset.index, 0);
          var numberOfSlides = parseInt(element.attr("data-number-of-slides"));
          element.slick("slickGoTo", clickedIndex);

          /* Create an array of the slide indices to be shown.
           * e.g. if NUMBER_OF_GRID_ITEMS=4, clickedIndex=4 and numberOfSlides=6,
           * the array would look like [4, 5, 0, 1]. */
          var slidesToShow = _toConsumableArray(Array(NUMBER_OF_GRID_ITEMS).keys()).map(function (index) {
            return (index + clickedIndex) % numberOfSlides;
          });
          document.querySelectorAll(".product__images--grid-item").forEach(function (slide) {
            var slideIndex = parseInt(slide.getAttribute("data-index"), 10);
            var shouldShow = slidesToShow.includes(slideIndex);
            var order = slidesToShow.indexOf(slideIndex);
            slide.classList.toggle("hide", !shouldShow);
            if (shouldShow) slide.setAttribute("data-order", order);
          });
        }
      },
      initVariants: function initVariants() {
        var variantJson = document.getElementById(this.selectors.variantsJson);
        if (!variantJson) {
          return;
        }
        this.variantsObject = JSON.parse(variantJson.innerHTML);
        this.container.querySelectorAll(this.selectors.singleOptionSelector).forEach(function (swatch) {
          swatch.addEventListener("change", function (event) {
            var el = event.currentTarget;
            var name = el.dataset.optionName;
            var index = el.dataset.optionIndex;
            this.updateColorName(name, index);
          }.bind(this));
        }.bind(this));
      },
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function updateColorName(color, index) {
        if (!this.variantsObject) return;
        document.querySelector(this.selectors.variantLabel(index)).textContent = color;
        var matchingSize = this.variantsObject.find(function (variant) {
          return variant.option1 === color;
        });

        /* For some reason if you call it in the same cycle it will be overriden by the original value, doing this correctly sets it */
        this.container.querySelector(this.selectors.originalSelectorId).value = matchingSize.id.toString();
        document.dispatchEvent(new CustomEvent("variant:change", {
          detail: matchingSize
        }));
      },
      updateSwatchLabel: function updateSwatchLabel(name, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(this.selectors.variantLabel(index)).textContent = name;
      },
      initQtySelector: function initQtySelector() {
        this.container.querySelectorAll(".js-qty__wrapper").forEach(function (el) {
          new theme.QtySelector(el, {
            namespace: ".product"
          });
        });
      },
      updatePrice: function updatePrice(evt) {
        var variant = evt.detail.variant;
        if (variant) {
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price);
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
            this.cache.priceA11y.setAttribute("aria-hidden", "false");
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
            }
            this.cache.priceA11y.setAttribute("aria-hidden", "true");
          }
        }
      },
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function openModalProduct() {
        var initialized = false;
        if (!this.settings.modalInit) {
          var formHolder = this.container.querySelector(this.selectors.modalFormHolder);
          var url = formHolder.dataset.url;
          var template = formHolder.dataset.template;

          // If no alt template, use stripped down ajax version
          if (template !== "preorder") {
            url = url + "?view=ajax";
          }
          fetch(url).then(function (response) {
            return response.text();
          }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            this.cache.form = doc.querySelector("#AddToCartForm-" + this.sectionId);
            console.log(doc);
            formHolder.innerHTML = "";
            formHolder.append(this.cache.form);
            formHolder.classList.add("product-form-holder--loaded");
            this.formSetup();
            document.dispatchEvent(new CustomEvent("quickview:loaded", {
              detail: {
                productId: this.sectionId
              }
            }));
          }.bind(this));

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initImageSlideshow();
            } else {
              document.addEventListener("quickview:loaded", function (evt) {
                if (evt.detail.productId === this.sectionId) {
                  this.initImageSlideshow();
                }
              }.bind(this));
            }
          } else {
            this.initImageSlideshow();
          }
          this.initLightbox();

          // this.customMediaListners();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }
        document.dispatchEvent(new CustomEvent("quickview:open", {
          detail: {
            initialized: initialized,
            productId: this.sectionId
          }
        }));
      },
      closeModalProduct: function closeModalProduct() {
        /* Nothing to do */
      },
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function updateModalProductInventory() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll(".js-product-inventory-data").forEach(function (el) {
          var sectionId = el.dataset.sectionId;
          window.inventories[sectionId] = {};
          el.querySelectorAll(".js-variant-inventory-data").forEach(function (el) {
            window.inventories[sectionId][el.dataset.id] = {
              quantity: el.dataset.quantity,
              incoming: el.dataset.incoming,
              next_incoming_date: el.dataset.date
            };
          });
        });
      }
    });
    return Product;
  }();
  theme.QtySelector = function () {
    var selectors = {
      input: ".js-qty__num",
      plus: ".js-qty__adjust--plus",
      minus: ".js-qty__adjust--minus",
      label: ".product__quantity--label-count"
    };
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.label = el.querySelector(selectors.label);
      this.minValue = this.input.getAttribute("min") || 1;
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
      this.options = Object.assign({}, defaults, options);
      this.init();
    }
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function init() {
        this.plus.addEventListener("click", function () {
          var qty = this._getQty();
          this._change(qty + 1);
        }.bind(this));
        this.minus.addEventListener("click", function () {
          var qty = this._getQty();
          this._change(qty - 1);
        }.bind(this));
        this.input.addEventListener("change", function (evt) {
          this._change(this._getQty());
        }.bind(this));
      },
      _getQty: function _getQty() {
        var qty = this.input.value;
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },
      _change: function _change(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
        this.input.value = qty;
        if (this.label) label.innerText = qty;
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent("cart:quantity" + this.options.namespace, {
            detail: [this.options.key, qty, this.wrapper]
          }));
        }
        this.input.dispatchEvent(new CustomEvent("valuechange", {
          detail: qty
        }));
      }
    });
    return QtySelector;
  }();
  window.isFetchingWishlist = true;
  window.isSavingToWishlist = false;
  theme.initWishlist = function () {
    var selectors = {
      productButton: ".product-wishlist-button"
    };

    // Prevent wiping existing wishlist data
    if (!window.wishlist) {
      window.wishlist = {};
    }

    // If we already have data, update the UI optimistically
    if (window.wishlist.productIds) {
      theme.updateNavbarWishlistCount();
      theme.updateAllProductWishlistButtons();
    }
    theme.fetchWishlist();
    $(selectors.productButton).on("click", function (event) {
      event.stopPropagation();
      if (window.isFetchingWishlist) return;
      var productId = event.currentTarget.dataset.productId;
      var isDeleting = window.wishlist && window.wishlist.productIds && window.wishlist.productIds.includes(productId);
      theme.saveProductToWishlist(productId, isDeleting)["catch"](function (error) {
        alert("An error occurred.\n\n" + error);
      });
    });
  };
  theme.enableCheckoutButtons = function () {
    document.querySelectorAll(".unavailable-to-checkout").forEach(function (element) {
      element.style.display = "none";
    });
    document.querySelectorAll(".checkout-button").forEach(function (element) {
      element.classList.remove("disabled");
      element.querySelector("i").style.display = "block";
      element.querySelector("span").innerText = "Checkout";
    });
  };
  theme.setCheckoutButtonsLoading = function () {
    document.querySelectorAll(".unavailable-to-checkout").forEach(function (element) {
      element.style.display = "none";
    });
    document.querySelectorAll(".checkout-button").forEach(function (element) {
      element.classList.add("disabled");
      element.querySelector("i").style.display = "none";
      element.querySelector("span").innerText = "Loading...";
    });
  };
  theme.disableCheckoutButtons = function () {
    document.querySelectorAll(".unavailable-to-checkout").forEach(function (element) {
      element.style.display = "block";
    });
    document.querySelectorAll(".checkout-button").forEach(function (element) {
      element.classList.add("disabled");
      element.querySelector("i").style.display = "block";
      element.querySelector("span").innerText = "Checkout";
    });
  };
  theme.setAddToCartButtonsLoadingQuickView = function () {
    var quickViewModal = $(".modal-quick-view.modal--open");
    var addToCartButton = quickViewModal.find(".add-to-cart");
    var addToCartButtonText = addToCartButton.find(".button--text");
    addToCartButton.attr("disabled", true);
    addToCartButtonText.text("Loading...");
    addToCartButton.find("i").css("display", "none");
    var paymentButton = quickViewModal.find(".shopify-payment-button");
    paymentButton.css("display", "none");
    var unavailableProduct = quickViewModal.find(".unavailable-to-add-product");
    unavailableProduct.css("display", "none");
    var unavailableProductSoh = quickViewModal.find(".unavailable-to-add-product-soh");
    unavailableProductSoh.css("display", "none");
  };
  theme.setAddToCartButtonsLoading = function () {
    var addToCartButton = $(".add-to-cart");
    addToCartButton.attr("disabled", true);
    addToCartButton.find(".button--text").text("Loading...");
    addToCartButton.find("i").css("display", "none");
    var addBundleToBagButton = $(".product-form__add-bundle-button");
    addBundleToBagButton.attr("disabled", true);
    addBundleToBagButton.find(".button--text").text("Loading...");
    addBundleToBagButton.find("i").css("display", "none");
    console.log(1);
    var paymentButton = document.querySelector(".shopify-payment-button");
    if (paymentButton) {
      paymentButton.style.display = "none";
    }
    document.querySelectorAll(".unavailable-to-add-product").forEach(function (element) {
      element.style.display = "none";
    });
    document.querySelectorAll(".unavailable-to-add-product-soh").forEach(function (element) {
      element.style.display = "none";
    });
  };
  theme.enableAddToCartButtons = function () {
    var addToCartButton = $(".add-to-cart");
    var addToCartButtonText = addToCartButton.find(".button--text");
    addToCartButton.removeAttr("disabled");
    addToCartButtonText.text(addToCartButtonText.attr("data-original-text"));
    addToCartButton.find("i").css("display", "block");
    var addBundleToBagButton = $(".product-form__add-bundle-button");
    var addBundleToBagButtonText = addBundleToBagButton.find(".button--text");
    addBundleToBagButton.removeAttr("disabled");
    addBundleToBagButtonText.text(addBundleToBagButtonText.attr("data-original-text"));
    addBundleToBagButton.find("i").css("display", "block");
    var paymentButton = document.querySelector(".shopify-payment-button");
    if (paymentButton) {
      paymentButton.style.display = "none";
    }
    document.querySelectorAll(".unavailable-to-add-product").forEach(function (element) {
      element.style.display = "none";
    });
  };
  theme.enableAddToCartButtonsQuickView = function (sku) {
    var quickViewModal = $(".modal-quick-view.modal--open");
    var addToCartButton = quickViewModal.find(".add-to-cart");
    var addToCartButtonText = addToCartButton.find(".button--text");
    addToCartButton.removeAttr("disabled");
    addToCartButtonText.text(addToCartButtonText.attr("data-original-text"));
    addToCartButton.find("i").css("display", "block");
    var paymentButton = quickViewModal.find(".shopify-payment-button");
    paymentButton.css("display", "block");
    var unavailableProduct = quickViewModal.find(".unavailable-to-add-product");
    unavailableProduct.css("display", "none");
  };
  theme.disableAddToCartButtons = function (discountCode) {
    var addToCartButton = $(".add-to-cart");
    var addToCartButtonText = addToCartButton.find(".button--text");
    addToCartButton.attr("disabled", true);
    addToCartButtonText.text(addToCartButtonText.attr("data-original-text"));
    addToCartButton.find("i").css("display", "block");
    var addBundleToBagButton = $(".product-form__add-bundle-button");
    var addBundleToBagButtonText = addBundleToBagButton.find(".button--text");
    addBundleToBagButton.attr("disabled", true);
    addBundleToBagButtonText.text(addBundleToBagButtonText.attr("data-original-text"));
    addBundleToBagButton.find("i").css("display", "block");
    var paymentButton = document.querySelector(".shopify-payment-button");
    if (paymentButton) {
      paymentButton.style.display = "none";
    }
    document.querySelectorAll(".unavailable-to-add-product").forEach(function (element) {
      element.style.display = "block";
    });
    if (discountCode) {
      document.querySelectorAll(".unavailable-to-add-product-code").forEach(function (element) {
        element.style.display = "block";
        element.innerHTML = "Use discount code: <b>" + discountCode + "</b> to get free shipping!";
      });
    }
  };
  theme.disableAddToCartButtonsQuickView = function (discountCode) {
    var quickViewModal = $(".modal-quick-view.modal--open");
    var addToCartButton = quickViewModal.find(".add-to-cart");
    var addToCartButtonText = addToCartButton.find(".button--text");
    addToCartButton.attr("disabled", true);
    addToCartButtonText.text(addToCartButtonText.attr("data-original-text"));
    addToCartButton.find("i").css("display", "block");
    var paymentButton = quickViewModal.find(".shopify-payment-button");
    paymentButton.css("display", "none");
    var unavailableProduct = quickViewModal.find(".unavailable-to-add-product");
    unavailableProduct.css("display", "block");
    if (discountCode) {
      var unavailableProduct = quickViewModal.find(".unavailable-to-add-product-code");
      unavailableProduct.css("display", "block");
      unavailableProduct.html("Use discount code: <b>" + discountCode + "</b> to get free shipping!");
    }
  };
  theme.validateCart = function () {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "checkout";
    var sku = arguments.length > 1 ? arguments[1] : undefined;
    var quantity = arguments.length > 2 ? arguments[2] : undefined;
    if (mode === "checkout") {
      theme.setCheckoutButtonsLoading();
    }
    if (mode === "product") {
      theme.setAddToCartButtonsLoading();
    }
    if (mode === "quickview") {
      theme.setAddToCartButtonsLoadingQuickView();
    }
    var handleResult = function handleResult(isAvailable, discountCode) {
      if (mode === "checkout") {
        if (isAvailable) {
          theme.enableCheckoutButtons();
        } else {
          theme.disableCheckoutButtons();
        }
      }
      if (mode === "product") {
        if (isAvailable) {
          theme.enableAddToCartButtons();
        } else {
          theme.disableAddToCartButtons(discountCode);
        }
      }
      if (mode === "quickview") {
        if (isAvailable) {
          setTimeout(function () {
            theme.enableAddToCartButtonsQuickView(sku);
          }, 1000);
        } else {
          theme.disableAddToCartButtonsQuickView(discountCode);
        }
      }
    };
    theme.utils.fetchWithTimeout("/cart.js", {}, 5000).then(function (response) {
      if (!response.ok) {
        throw new Error("Response not 200");
      }
      return response.json();
    }).then(function (cartData) {
      theme.checkCartRouting(cartData, handleResult, {
        sku: sku,
        quantity: quantity
      });
    })["catch"](function (e) {
      console.error("Failed to validate cart contents, failing open");
      console.error(e);
      handleResult(true);
    });
  };
  theme.checkCartRouting = function (cartData, callback, additionalItem) {
    try {
      /* Get customer's location (Country Code)  */
      fetch("/cdn-cgi/trace").then(function (locationResponse) {
        return locationResponse.text();
      }).then(function (locationText) {
        /* Convert text response to JSON Object */
        var data = locationText.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
        data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';
        var locationData = JSON.parse(data);
        // If website is NZ, assume customer is NZ (easier for client to manage website while based in Aus)
        var countryCode = document.location.hostname.endsWith("co.nz") ? "NZ" : locationData.loc;
        if (cartData.item_count === 0 && countryCode === "AU") {
          /* Enable any checkout buttons (although they should never show) */
          return callback(true);
        }
        /* Determine our cart data */
        var itemData = cartData.items.map(function (item) {
          return {
            sku: item.sku,
            quantity: item.quantity
          };
        });
        if (additionalItem && additionalItem.sku) {
          itemData.push(additionalItem);
        }

        /* Check our routing endpoint */
        theme.utils.fetchWithTimeout(theme.ENV.apiUrl + "/inventory/routing/v1", {
          method: "POST",
          body: JSON.stringify({
            lines: itemData,
            country: countryCode
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }, 2000).then(function (response) {
          if (!response.ok) {
            throw new Error("Response not 200");
          }
          return response.json();
        }).then(function (routing) {
          if (routing.available) {
            /* Show checkout button */
            console.log("Routing available");
            callback(true);
          } else {
            /* Disable checkout button */
            console.log("Routing unavailable");
            callback(false, routing.discount);
          }
        })["catch"](function (e) {
          console.error("Failed to determine cart routing, failing open");
          console.error(e);
          callback(true);
        });
      })["catch"](function (e) {
        console.error("Failed to determine customer location, failing open");
        console.error(e);
        callback(true);
      });
    } catch (e) {
      console.error("Failed to validate cart contents, failing open");
      console.error(e);
      callback(true);
    }
  };
  theme.updateNavbarWishlistCount = function () {
    var selectors = {
      navbarButtonCount: ".header__wishlist-count"
    };
    var element = $(selectors.navbarButtonCount);
    var count = window.wishlist.productIds && window.wishlist.productIds.length || 0;
    element.text(count);
    if (count > 0) {
      element.addClass("visible");
    } else {
      element.removeClass("visible");
    }
  };
  theme.updateAllProductWishlistButtons = function () {
    var selectors = {
      productButton: ".product-wishlist-button"
    };
    $(selectors.productButton).each(function (index, button) {
      var productId = button.dataset.productId;
      var isWishlisted = wishlist.productIds && wishlist.productIds.includes(productId);
      if (isWishlisted) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });
  };
  theme.updateProductWishlistButton = function (productId, isWishlisted) {
    var selectors = {
      productButton: '.product-wishlist-button[data-product-id="' + productId + '"]'
    };
    $(selectors.productButton).each(function (index, button) {
      if (isWishlisted) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });
  };
  theme.fetchWishlist = function () {
    var url = theme.ENV.apiUrl + "/wishlist";
    var email = window.customer && window.customer.email;
    var guestID = window.localStorage.getItem(theme.constants.LOCALSTORAGE_GUEST_ID);
    if (!guestID) {
      guestID = uuidv4();
      window.localStorage.setItem(theme.constants.LOCALSTORAGE_GUEST_ID, guestID);
    }
    url += "?email=" + encodeURIComponent(email || guestID + "@guest.fila.com.au");
    if (email) {
      url += "&guestID=" + guestID;
    }
    return fetch(url).then(function (response) {
      return response.json();
    }).then(function (wishlist) {
      window.wishlist = wishlist;
      theme.updateNavbarWishlistCount();
      theme.updateAllProductWishlistButtons();
      window.isFetchingWishlist = false;
      return wishlist;
    });
  };
  theme.saveProductToWishlist = function (productId, isDeleting) {
    if (window.isFetchingWishlist || isSavingToWishlist) return;
    window.isSavingToWishlist = true;
    var url = theme.ENV.apiUrl + "/wishlist";
    var email = window.customer && window.customer.email;
    var guestID = window.localStorage.getItem(theme.constants.LOCALSTORAGE_GUEST_ID);
    var body = {
      productId: productId
    };
    body.email = email || guestID + "@guest.fila.com.au";

    /* Optimistically update the UI */
    theme.updateProductWishlistButton(productId, !isDeleting);
    return fetch(url, {
      method: isDeleting ? "DELETE" : "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      return response.json();
    }).then(function (wishlist) {
      window.wishlist = wishlist;
      theme.updateNavbarWishlistCount();
      window.isSavingToWishlist = false;
      return wishlist;
    })["catch"](function (error) {
      console.warn(error);
      theme.updateProductWishlistButton(productId, isDeleting); // Revert the button if error
      window.isSavingToWishlist = false;
    });
  };
  theme.ensureGuestID = function () {
    var guestID = window.localStorage.getItem(theme.constants.LOCALSTORAGE_GUEST_ID);
    if (!guestID) {
      guestID = uuidv4();
      window.localStorage.setItem(theme.constants.LOCALSTORAGE_GUEST_ID, guestID);
    }
  };
  theme.recordProductView = function (productId) {
    theme.ensureGuestID();
    var guestID = window.localStorage.getItem(theme.constants.LOCALSTORAGE_GUEST_ID);
    var url = theme.ENV.apiUrl + "/recently-viewed";
    var body = {
      productId: productId,
      guestID: guestID
    };
    return fetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json"
      }
    });
  };
  theme.getRecentlyViewed = function () {
    theme.ensureGuestID();
    var url = theme.ENV.apiUrl + "/recently-viewed";
    var guestID = window.localStorage.getItem(theme.constants.LOCALSTORAGE_GUEST_ID);
    url += "?guestID=" + guestID + "&productId=0";
    return fetch(url).then(function (response) {
      return response.json();
    }).then(function (data) {
      return data;
    });
  };
  theme.initQuickShop = function () {
    var ids = [];
    var products = document.querySelectorAll('[data-enable-quick-view="true"]');
    if (!products.length) {
      return;
    }
    products.forEach(function (product) {
      product.addEventListener("mouseenter", productMouseover);
    });
    function productMouseover(evt) {
      var el = evt.currentTarget;
      el.removeEventListener("mouseenter", productMouseover);
      if (!el || !el.dataset.productId) {
        // Onboarding product, no real data
        return;
      }
      var productId = el.dataset.productId;
      var handle = el.dataset.productHandle;
      var btn = el.querySelector(".product-card__quick-view-button");
      theme.preloadProductModal(handle, productId, btn);
    }
  };
  theme.preloadProductModal = function (handle, productId, btn) {
    var holder = document.getElementById("QuickViewHolder-" + handle);
    var url = theme.routes.home + "/products/" + handle + "?view=modal";

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace("//", "/");
    fetch(url).then(function (response) {
      return response.text();
    }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var div = doc.querySelector('.product[data-product-handle="' + handle + '"]');
      if (!holder) {
        return;
      }
      holder.append(div);

      // Setup quick view modal
      var modalId = "QuickViewModal-" + productId;
      var name = "quick-view-" + productId;
      var modal = new theme.Modals(modalId, name);

      // Register product template inside quick view
      theme.sections.register("product", theme.Product, holder);

      // Register collapsible elements
      // theme.collapsibles.init();

      // Register potential video modal links (when video has sound)
      // theme.videoModal();

      if (btn) {
        btn.classList.remove("product-card__quick-view-button--not-ready");
      }

      // Non-specific; could be improved
      if (window.pendingOpenQuickViewEvent) {
        modal.open();
        window.pendingOpenQuickViewEvent = null;
      }
    });
  };
  theme.recoverAccount = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(email) {
      var url;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = theme.ENV.apiUrl + "/loyalty/recover-account/".concat(email);
              console.log(url);
              return _context.abrupt("return", fetch(url, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                }
              }).then(function (response) {
                return response.json();
              }).then(function (data) {
                return data;
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();
  window.storefrontApi = {
    createCustomerAccessToken: function createCustomerAccessToken(email, password) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n            mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {\n              customerAccessTokenCreate(input: $input) {\n                customerAccessToken {\n                  accessToken\n                  expiresAt\n                }\n                customerUserErrors {\n                  code\n                  field\n                  message\n                }\n              }\n            }\n          ",
          variables: {
            input: {
              email: email,
              password: password
            }
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerAccessTokenCreate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customerAccessToken.accessToken;
      });
    },
    updateCustomer: function updateCustomer(accessToken, values) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n            mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {\n              customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {\n                customer {\n                  id\n                  firstName\n                  lastName\n                  phone\n                  acceptsMarketing\n                  email\n                }\n                customerAccessToken {\n                  accessToken\n                  expiresAt\n                }\n                customerUserErrors {\n                  code\n                  field\n                  message\n                }\n              }\n            }\n          ",
          variables: {
            customerAccessToken: accessToken,
            customer: values
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerUpdate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customer;
      });
    },
    createCustomerAddress: function createCustomerAddress(accessToken, values) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n              mutation customerAddressCreate($customerAccessToken: String!, $address: MailingAddressInput!) {\n                customerAddressCreate(\n                  customerAccessToken: $customerAccessToken\n                  address: $address\n                ) {\n                  customerAddress {\n                    id\n                  }\n                  customerUserErrors {\n                    code\n                    field\n                    message\n                  }\n                }\n              }\n          ",
          variables: {
            customerAccessToken: accessToken,
            address: values
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerAddressCreate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customer;
      });
    },
    updateCustomerAddress: function updateCustomerAddress(accessToken, addressID, values) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n              mutation customerAddressUpdate($customerAccessToken: String!, $id: ID!, $address: MailingAddressInput!) {\n                customerAddressUpdate(\n                  customerAccessToken: $customerAccessToken\n                  id: $id\n                  address: $address\n                ) {\n                  customerAddress {\n                    id\n                  }\n                  customerUserErrors {\n                    code\n                    field\n                    message\n                  }\n                }\n              }\n          ",
          variables: {
            customerAccessToken: accessToken,
            id: addressID,
            address: values
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerAddressUpdate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customerAddress;
      });
    },
    deleteCustomerAddress: function deleteCustomerAddress(accessToken, addressID) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n              mutation customerAddressDelete($id: ID!, $customerAccessToken: String!) {\n                customerAddressDelete(id: $id, customerAccessToken: $customerAccessToken) {\n                  customerUserErrors {\n                    code\n                    field\n                    message\n                  }\n                  deletedCustomerAddressId\n                }\n              }\n          ",
          variables: {
            customerAccessToken: accessToken,
            id: addressID
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerAddressDelete;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.deletedCustomerAddressId;
      });
    },
    customerRecovery: function customerRecovery(email) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n            mutation customerRecover($email: String!) {\n              customerRecover(email: $email) {\n                customerUserErrors {\n                  code\n                  field\n                  message\n                }\n              }\n            }\n          ",
          variables: {
            email: email
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerRecover;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.deletedCustomerAddressId;
      });
    }
  };
  $(document).ready(function () {
    theme.sections = new theme.Sections();
    theme.sections.register("product", theme.Product);
    theme.initQuickShop();
    theme.initWishlist();
    if (Shopify && Shopify.theme && Shopify.theme.name.endsWith(" Dev")) {
      document.body.classList.add("is-dev");
    }
  });
  theme.ensureGuestID();
})();
function getCoords(elem) {
  // crossbrowser version
  var box = elem.getBoundingClientRect();
  var body = document.body;
  var docEl = document.documentElement;
  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;
  return {
    top: Math.round(top),
    left: Math.round(left)
  };
}

/* Disclosure */
$(function () {
  var selectors = {
    openButton: ".disclosure__open-button"
  };
  function init() {
    $(selectors.openButton).on("click", handleToggle);
  }
  function destroy() {
    $(selectors.openButton).off("click", handleToggle);
  }
  function handleToggle(event) {
    var ANIMATION_DURATION_MS = 200;
    var body = $(event.currentTarget).next();
    var isOpening = body.is(":hidden");
    body.slideToggle(ANIMATION_DURATION_MS);
    $(event.currentTarget).find(".icon").toggleClass("rotate-180");
    if (isOpening) {
      var isMobile = window.matchMedia("(max-width: 767px)").matches;

      /* Only control scroll if on mobile */
      if (!isMobile) return;

      /* Once the dropdown animation is finished, scroll what was just clicked into view. */
      setTimeout(function () {
        event.currentTarget.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }, ANIMATION_DURATION_MS);
    }
  }
  init();
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", destroy);
});
$(document).ready(function () {
  $(".product-quick-add select").on("change", function (e) {
    e.target.parentNode.querySelector("button").disabled = !e.target.value;
  });
  $(".product-quick-add button").on("click", function (e) {
    var variantID = e.target.parentNode.querySelector("select").value;
    e.target.innerText = "LOADING...";
    e.target.disabled = true;
    var hasBundle = e.target.getAttribute("data-has-off") === "true";
    showBundle(hasBundle, {
      variantID: variantID,
      quantity: 1,
      bool: false
    });
  });
});
function showBundle(hasBundle, orderConfig) {
  if (hasBundle) {
    var base = document.querySelector("#kit-builder-v2-react-root-".concat(orderConfig.productId));
    if (base === undefined || base === null) {
      var singleProductView = document.querySelector("#kit-builder-v2-react-root");
      if (singleProductView) {
        singleProductView.style.display = "unset";
      }
      return;
    }
    base.style.display = "unset";
    return;
  }
  var variantID = orderConfig.variantID,
    quantity = orderConfig.quantity,
    bool = orderConfig.bool;
  addToCart(variantID, quantity, bool);
}
function addCrossSellToCard(variantId) {
  addToCart(variantId, 1, false, undefined, true);
}
function toggleUpsellModule() {
  var upsellModule = document.querySelector("div#product-upsell-react-root");
  var noProducts = upsellModule.children[0].getAttribute("data-no-products");
  if (noProducts === "true") {
    return;
  }
  if (upsellModule.getAttribute("style").includes("none")) {
    upsellModule.style.display = "unset";
    setTimeout(function () {
      var upsellModule = document.querySelector("div#product-upsell-react-root");
      var backdrop = upsellModule.children[0];
      console.log(upsellModule);
      backdrop.style.opacity = 1;
      var child = upsellModule.children[0].children[0];
      child.style.opacity = 1;
      child.style.transform = "translateY(0)";
    }, 200);
    return;
  }
  var backdrop = upsellModule.children[0];
  console.log(upsellModule);
  backdrop.style.opacity = 0;
  var child = upsellModule.children[0].children[0];
  child.style.opacity = 0;
  child.style.transform = "translateY(5em)";
  setTimeout(function () {
    upsellModule.style.display = "none";
  }, 200);
}
function handleProductBundleCreate(baseProductVariantId) {
  var variantID = document.querySelector(".select.product-form__variants").value;
  var promo = document.querySelector("input#variant-id-selector-".concat(variantID)).getAttribute("data-variant-ids").split(",");
  var groupId = document.querySelector("input#variant-id-selector-".concat(variantID)).getAttribute("data-group-id");
  try {
    addBundleToCart(variantID, promo, 1, groupId);
  } catch (e) {
    console.log(e);
    addToCart(variantID, 1);
  }
}
function handleQuickViewButtonClick(event) {
  event.stopPropagation();
  event.preventDefault();
  if (event.currentTarget.classList.contains("product-card__quick-view-button--not-ready")) {
    window.pendingOpenQuickViewEvent = event;
  }
}